import { useState } from "react";
import { BsEyeFill, BsFillEyeSlashFill } from "react-icons/bs";

interface IInput {
    id: string;
    type?: string;
    label: string;
    className?: string;
    title?: string;
    // `false` tira o olho individual: quem usa passa a controlar `type` por fora (ex: um unico
    // botao que mostra/oculta varios campos de senha ao mesmo tempo).
    showToggle?: boolean;
    [key: string]: any;
}

export default function Input({
    id,
    type = 'text',
    label,
    className = '',
    title = '',
    showToggle = true,
    ...rest
}: IInput) {
    const [inputType, setInputType] = useState(type);

    const toggleInputType = () => {
        setInputType(inputType === 'text' ? 'password' : 'text');
    };

    return (
        <div className={'form-input ' + className}>
            <input id={id} type={showToggle ? inputType : type} placeholder='' title={title} autoComplete='one-time-code' {...rest}/>
            <label htmlFor={id}>{label}</label>
            {showToggle && type === 'password' && (
                <button type="button" onClick={toggleInputType}>
                    <span role="img" aria-label="eye">
                        {inputType === "password" ? <BsEyeFill size={20} color="#4a4949"/> : <BsFillEyeSlashFill size={20} color="#4a4949"/>}
                    </span>
                </button>
            )}
        </div>
    )
}